export const TESTING_SITES = {
  CLINIC: 'clinic'
}
